"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OntologyTestnetConfig = void 0;
const Tokens_1 = require("./Tokens");
const Types_1 = require("../../Types");
const MetamaskConnector_1 = require("../../Connectors/Wallets/MetamaskConnector");
const Utils_1 = require("../Utils");
const MetamaskCompatibleConnector_1 = require("../../Connectors/Wallets/MetamaskCompatibleConnector");
const Factory_1 = require("../../Connectors/Factory");
const Utils_2 = require("../../Connectors/Utils");
const WalletConnectConnector_1 = require("../../Connectors/Wallets/WalletConnectConnector");
const CoinbaseConnector_1 = require("../../Connectors/Wallets/CoinbaseConnector");
const TokenPocketConnector_1 = require("../../Connectors/Wallets/TokenPocketConnector");
exports.OntologyTestnetConfig = Utils_1.blockchainConfigFactory({
    blockchain: Types_1.Blockchains.OntologyTestnet,
    chainId: Types_1.EthChainIds.OntologyTestnet,
    publicRpc: Utils_2.unifiBlockchainProxyUrl(Types_1.Blockchains.OntologyTestnet),
    nativeToken: Tokens_1.ONGNativeToken,
    wrappedToken: Tokens_1.ONGWrappedToken,
    upToken: Tokens_1.ONGUpToken,
    logoURI: "https://proxy.unifiprotocol.com/ipfs/QmXRH7VxcrLM9mP3si1f4A82UPcgyqEiSWJtNzHKkVeUW2",
    multicall: {
        supported: true,
        address: "0x814D299c9081085C6b99208f1387738EeD3D638F",
        tryAggregate: false,
    },
    connectorFactory: Factory_1.web3ConnectorFactory,
    explorer: {
        baseUrl: `https://explorer.ont.io/testnet`,
        address: function (address) {
            return `${this.baseUrl}/address/${address}`;
        },
        token: function (address) {
            return `${this.baseUrl}/token/${address}`;
        },
        tx: function (address) {
            return `${this.baseUrl}/tx/${address}`;
        },
    },
}, [
    MetamaskConnector_1.MetamaskConnector,
    TokenPocketConnector_1.TokenPocketConnector,
    MetamaskCompatibleConnector_1.MetamaskCompatibleConnector,
    CoinbaseConnector_1.CoinbaseWalletConnector,
    WalletConnectConnector_1.WalletConnectConnector,
], [
    Factory_1.createWeb3OfflineConnectorHelper(Types_1.OfflineConnectors.OntologyTestnet, Utils_2.unifiBlockchainProxyUrl(Types_1.Blockchains.OntologyTestnet)),
]);
